import * as shortid from './shortid';

export { shortid };
